/**
 * Common skills by role family. Matched via case-insensitive substring.
 * Returns suggested skills minus those the user already has.
 */
const ROLE_SKILLS: Record<string, string[]> = {
  "software engineer": [
    "JavaScript", "TypeScript", "Python", "Git", "SQL",
    "REST APIs", "Testing", "CI/CD", "System Design", "Code Review"
  ],
  "product manager": [
    "Roadmapping", "User Research", "Stakeholder Management", "Agile/Scrum",
    "Data Analysis", "Wireframing", "A/B Testing", "OKRs", "Prioritization"
  ],
  "data analyst": [
    "SQL", "Excel", "Python", "Data Visualization", "Statistics",
    "Tableau/Power BI", "ETL", "A/B Testing", "Dashboard Design"
  ],
  "data scientist": [
    "Python", "Machine Learning", "Statistics", "SQL", "Data Visualization",
    "Deep Learning", "Feature Engineering", "A/B Testing", "R"
  ],
  "designer": [
    "Figma", "User Research", "Wireframing", "Prototyping", "Design Systems",
    "Accessibility", "Visual Design", "Information Architecture"
  ],
  "engineering manager": [
    "People Management", "1:1s", "Technical Strategy", "Hiring",
    "Performance Reviews", "Agile/Scrum", "Cross-Team Collaboration",
    "Architecture Review", "Mentoring", "Stakeholder Communication"
  ],
  "marketing": [
    "Content Strategy", "SEO", "Analytics", "Social Media",
    "Email Marketing", "A/B Testing", "Brand Management", "Copywriting"
  ],
  "sales": [
    "Pipeline Management", "CRM", "Negotiation", "Prospecting",
    "Account Management", "Presentation Skills", "Forecasting"
  ],
  "project manager": [
    "Agile/Scrum", "Stakeholder Management", "Risk Management",
    "Resource Planning", "Gantt Charts", "JIRA", "Communication",
    "Budget Management", "Conflict Resolution"
  ],
  "consultant": [
    "Stakeholder Management", "Presentation Skills", "Data Analysis",
    "Problem Solving", "Client Management", "Strategy", "Change Management"
  ],
};

export function getSuggestedSkills(
  jobRole: string,
  existingSkills: string[]
): string[] {
  const roleLower = jobRole.toLowerCase();
  const existingLower = new Set(existingSkills.map(s => s.toLowerCase()));

  for (const [roleKey, skills] of Object.entries(ROLE_SKILLS)) {
    if (roleLower.includes(roleKey) || roleKey.includes(roleLower)) {
      return skills.filter(s => !existingLower.has(s.toLowerCase()));
    }
  }
  return [];
}
